if (!window.fbControls) window.fbControls = [];
window.fbControls.push(function (controlClass) {
	class controlRedirectInXSec extends controlClass {
		static get definition() {
			return {
				icon: '<i class="fa fa-forward" aria-hidden="true"></i>',
				i18n: {
					default: 'Redirect In x Seconds'
				}
			};
		}
		configure() { }
		build() {
			let fieldContainerAttributes = this.config.fieldContainerAttributes || '';
			let className = this.config.className || '';
      let name = this.config.name;
      let prefixMessage = this.config.prefixMessage || 'You will be redirected to next page in ';
      let suffixMessage = this.config.suffixMessage || 'seconds';
      let redirectInSeconds = parseInt(this.config.redirectInSeconds) || 1;
			let template = 
        `<div id="${name}_redirectInXSec" ${(fieldContainerAttributes) ? fieldContainerAttributes : '' } class="${className}">` +
          `<span 
            id="${name}_prefixMessage" 
            class="prefixMessage">
            ${prefixMessage}
          </span>`+
          `<span 
						id="${name}_redirectInSeconds"
            class="redirectInSeconds">
            ${redirectInSeconds}
          </span>`+
          `<span 
            id="${name}_suffixMessage" 
            class="suffixMessage">
            ${suffixMessage}
          </span>`+
				'</div>'
			return template;
		}

		onRender() {
		}
	}
	controlClass.register('redirectInXSec', controlRedirectInXSec);
	return controlRedirectInXSec;
});
